const colleges = {
  all_colleges: '🚸 Todos los colegios',
  create: 'Crear Nuevo Colegio',
  // Formulario de creación nativo
  school_name_label: 'Nombre del colegio',
  country_label: 'País',
  operation_year_label: 'Año de inicio',
  school_group_label: 'Conglomerado (opcional)',
  rbd_label: 'RBD / código externo (opcional)',
  contact_label: 'Persona de contacto (opcional)',
  phone_label: 'Teléfono (opcional)',
  state_label: 'Estado (EE. UU.)',
  time_zone_label: 'Zona horaria',
  created_title: 'Colegio creado',
  created_info: 'ID: {id} · Nombre: {name}',
  create_another: 'Crear otro',
  create_error: 'No se pudo crear el colegio. Inténtalo de nuevo.',
  name_exists: 'Ya existe un colegio con ese nombre en el país seleccionado',
  tab_school: 'Colegio',
  tab_contract: 'Contrato',
  email_cs_label: 'Email CS',
  create_arrangement_error: 'Colegio creado, pero no se pudo guardar el contrato.',
  active: 'Activo',
  inactive: 'Inactivo',
  detail: 'Detalle',
  migrate_period: 'Migrar periodo',
  disable_college: 'Deshabilitar colegio(s)',
  filters: 'Filtros',
  clean_up: 'Limpiar',
  search: 'Buscar',
  status: 'Estatus',
  country: 'País',
  school_name: 'Nombre del colegio',
  edit: 'Editar',
  general_information: 'Información general',
  creation: 'Creación',
  sale: 'Venta',
  commune: 'Comuna',
  contact: 'Contacto',
  phone: 'Teléfono',
  analytics: '📊 Panel de Estadísticas 🎓  ',
  current_period_of_operation: 'Periodo actual de operación',
  success_edition_msg: 'El colegio se editó con éxito.',
  error_edition_msg: '¡Algo salió mal! Intenta realizar esta misma acción más tarde.',
  students_migrated: 'Los estudiantes han sido migrados',
  massive_load: 'Carga Masiva',
  massive_load_pending: 'En cola para procesar...',
  massive_load_processing: 'Procesando carga...',
  massive_load_failed: 'La carga falló.',
  massive_load_completed: 'Carga completada.',
  upload_summary: 'Resumen de carga',
  upload_summary_sede: 'Sede',
  upload_summary_aula: 'Aula',
  upload_summary_expected: 'Total en Excel',
  upload_summary_processed: 'Procesados',
  upload_summary_not_processed: 'No procesados',
  upload_summary_directives: 'Directivos',
  upload_summary_teachers: 'Docentes',
  upload_summary_students: 'Estudiantes',
  upload_summary_total: 'Total',
  new_course: 'Crear curso',
  course_saved_success: 'Curso guardado de manera exitosa',
  school_id: 'ID del colegio',
  payment_identifier: 'Tipo de pagador',
  excel_format: 'Formato del Excel',
  see_an_example: 'Ver ejemplo',
  users_have_DNI_label: '¿Los usuarios tienen DNI?',
  users_have_DNI_yes: 'Sí',
  users_have_DNI_no: 'No',
  dissable_old_data_label: '¿Deshabilitar los datos viejos?',
  dissable_old_data_yes: 'Sí',
  dissable_old_data_no: 'No',
  file: 'Archivo',
  file_placeholder: 'Elija un archivo...',
  error_list: 'Lista de errores',
  successful_upload: '¡Carga exitosa!',
  save_as_txt: 'Guardar como txt',
  massive_load_warning: 'Se desactivarán los estudiantes que no estén en el documento.',
  select_group: 'Selecciona grupo de colegios',
  reports: 'Reportes',
  reports_see_column: 'Ver',
  school_arrangement: 'Información del Acuerdo con el Colegio',
  arrangement_name: 'Nombre del Acuerdo',
  total_licenses: 'Total de licencias',
  arrangement_range_dates: 'Fechas del Acuerdo',
  enrollment_type: 'Tipo de Acuerdo',
  select_enrollment_type: 'Selecciona el tipo de acuerdo',
  create_school_group: 'Crear conglomerado',
  school_group: 'Conglomerado',
  select_school_group: 'Selecciona un conglomerado',
  school_arrangement_is_invalid: 'La información del acuerdo con el colegio es inválida',
  hide_personal_books: 'Ocultar libros personales',
  only_allow_sso: 'Solo permitir inicio de sesión con Google (bloquea usuario y contraseña)',
  disable_autonomous_fluency: 'No permitir la grabación autónoma de fluidez (los alumnos solo graban con el docente)',
  calendar_type: 'Tipo de Calendario',
  select_calendar_type: 'Selecciona un tipo de calendario',
  calendar_type_load_error: 'No se pudieron cargar los tipos de calendario. Inténtalo de nuevo.',
  academic_periods: 'Periodos Lectivos',
  period_name: 'Nombre del Periodo',
  start_date: 'Fecha de Inicio',
  end_date: 'Fecha de Fin',
  period_type: 'Tipo',
  default_period: 'Por Defecto',
  custom_period: 'Personalizado',
  create_period: 'Crear Periodo',
  edit_period: 'Editar Periodo',
  delete_period: 'Eliminar Periodo',
  period_created_success: 'Periodo lectivo creado exitosamente',
  period_updated_success: 'Periodo lectivo actualizado exitosamente',
  period_deleted_success: 'Periodo lectivo eliminado exitosamente',
  period_error: 'Error al gestionar el periodo lectivo',
  confirm_delete_period: '¿Estás seguro de que deseas eliminar este periodo?',
  delete_period_warning: 'Esta acción no se puede deshacer.',
  validation_start_before_end: 'La fecha de inicio debe ser anterior a la fecha de fin',
  validation_type_a_start: 'Para Tipo A, la fecha de inicio debe estar entre el 1 de febrero y el 1 de abril',
  validation_type_a_end: 'Para Tipo A, la fecha de fin debe estar entre el 1 de noviembre y el 1 de enero',
  validation_type_b_start: 'Para Tipo B, la fecha de inicio debe estar entre el 1 de junio y el 1 de septiembre',
  validation_type_b_end: 'Para Tipo B, la fecha de fin debe estar entre el 1 de mayo y el 1 de julio',
  validation_type_c_start: 'Para Tipo C, la fecha de inicio debe estar entre el 1 de abril y el 1 de junio',
  validation_type_c_end: 'Para Tipo C, la fecha de fin debe estar entre el 1 de enero y el 1 de marzo',
  validation_type_start: 'La fecha de inicio no está dentro del rango esperado para este tipo de calendario',
  validation_type_end: 'La fecha de fin no está dentro del rango esperado para este tipo de calendario',
  validation_custom_start: 'La fecha de inicio del periodo personalizado debe ser posterior al {endDate} del periodo por defecto vigente ({periodName})',
  validation_custom_end: 'La fecha de fin del periodo personalizado debe ser anterior a la fecha de inicio del próximo periodo por defecto más un año',
  validation_overlap: "Las fechas se solapan con el periodo '{periodName}' ({startDate} – {endDate})",
  no_periods_found: 'No se encontraron periodos lectivos',
  calendar_type_updated: 'Tipo de calendario actualizado exitosamente',
  editing_default_period_info: 'Este es un periodo por defecto vinculado a un tipo de calendario. Editar sus fechas redefine automáticamente la fecha de inicio del próximo periodo lectivo de este tipo de calendario.',
  creating_custom_period_info: 'Los periodos personalizados se pueden crear entre periodos por defecto. Serán marcados como personalizados.',
  cannot_delete_default: 'No se pueden eliminar periodos por defecto',
  cannot_delete_started: 'No se puede eliminar un periodo que ya comenzó',
  edit_started_period: 'Editar Periodo (ya comenzó: solo nombre y extensión)',
  edit_ended_period: 'Editar Periodo (ya finalizó: no se puede editar)',
  start_date_locked_hint: 'El periodo ya comenzó: la fecha de inicio no se puede cambiar',
  editing_started_period_info: 'Este periodo ya comenzó. Puedes cambiar el nombre y '
    + 'extender la fecha de fin, pero no mover la fecha de inicio ni acortar el periodo.',
  validation_started_period_end: 'El periodo ya comenzó: la fecha de fin solo se puede '
    + 'extender, no adelantar',
  period_ended_alert: 'Este periodo lectivo ya finalizó y no puede editarse.',
  agreement_history: 'Historial de Acuerdos',
  inherited_agreement: 'Acuerdo del Colegio',
  agreement_managed_by_conglomerate: 'Este colegio pertenece a un conglomerado. El acuerdo se gestiona desde el conglomerado.',
  view_conglomerate_agreement: 'Ver acuerdo del conglomerado',
};

export default colleges;
